import React, { useEffect } from "react";
import {
  SidebarComponent,
  SidebarSlider,
  SidebarBodyComponent,

} from "../../components/index";
import { DefaultSearch } from "../../hooks/axiosBase";
import { useYoutubeSearch } from "../../hooks/request-handler";
// import {Popular} from '../../dummy/poular'
import "./home.css";
function Home({ show }) {

  var mostPopular=useYoutubeSearch(DefaultSearch)
  useEffect(() => {
    localStorage.removeItem("watchVideo");
    sessionStorage.removeItem("query")
  }, []);

  return (
    <div className="home">
      <div className="home__left">
        {!show ? <SidebarSlider /> : <SidebarComponent />}
      </div>
      <div
        style={{ marginLeft: `${!show ? "227px" : "88px"}` }}
        className="home__right"
      >
        {/* <RecommendSlider /> */}

        <SidebarBodyComponent most={mostPopular} />
       
      </div>
    </div>
  );
}

export default Home;




//GET https://youtube.googleapis.com/youtube/v3/search?part=snippet&relatedToVideoId=Ks-_Mh1QhMc&type=video&key=[YOUR_API_KEY] HTTP/1.1


